module.exports = __webpack_public_path__ + "static/media/reflex-actualites.79c5383f.png";